import React from 'react';
import { StyledFeeSection, StyledFeeSectionHeader } from './FeeSections.Styled';
import { IFeeSection } from './organizeFees';
import { FlexRow, Header3Text } from 'ui-toolkit';
import { FeeSectionTable } from './table/FeeSectionTable';
import { assertDefined } from 'utilities/Assertions';
import { useParams } from 'react-router-dom';
import { useSelectCurrentOrder } from 'selectors/order/selectCurrentOrder';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LinkTW } from 'tailwindComponents/link/LinkTW';
import { FeeTabs, clientUrls } from 'ui-toolkit/rest/ClientUrlFactory';
import { EditContainer } from './edit/EditContainer';
import { Validation } from './validation/Validation';
import { useHasPermissions } from '../../accessControl/hooks/useHasPermissions';
import { ePermissions } from 'types/administration/userAdministration/ePermissions';
import { eTransactionCategory } from '../../../ui-toolkit/enums/eTransactionType';

export interface IMiscDisbursementsContainerProps {
  feeSections: IFeeSection[];
}

export const MiscDisbursementsContainer: React.FC<IMiscDisbursementsContainerProps> = ({ feeSections }) => {
  const feeSection = feeSections.find((t) => t.sectionDefinition.sectionDescription === 'Misc Disbursements');
  assertDefined(feeSection);
  const params = useParams<{ section: FeeTabs; feeId: string }>();
  const { section, feeId } = params;
  const showEdit = feeId === feeSection.sectionDefinition.statementSectionDefinitionId;
  const hasEditPermission = useHasPermissions([ePermissions.CdItemsV3Edit]);
  const hasOptions = hasEditPermission && !!feeSection.options.length;
  const currentOrder = useSelectCurrentOrder();
  const sectionDescription = feeSection.sectionDefinition.sectionDescription;
  const orderId = currentOrder.data.transaction.id;
  assertDefined(orderId);

  return (
    <StyledFeeSection>
      <StyledFeeSectionHeader>
        <Header3Text>
          {feeSection.sectionDefinition.sectionLetter && `${feeSection.sectionDefinition.sectionLetter}.`}
          {sectionDescription}
        </Header3Text>
        {hasOptions && !showEdit && (
          <LinkTW
            isButton
            to={clientUrls.urlFor.feesTabEdit(
              orderId,
              section,
              feeSection.sectionDefinition.statementSectionDefinitionId
            )}
          >
            <FlexRow gap={'spacing2'}>
              <FontAwesomeIcon icon={faPlus} />
              Add
            </FlexRow>
          </LinkTW>
        )}
      </StyledFeeSectionHeader>
      {feeSection.sectionData && (
        <Validation
          sections={[feeSection.sectionData]}
          sectionDefinitions={[feeSection.sectionDefinition]}
          className={'grid p-4'}
        />
      )}
      {showEdit && (
        <EditContainer
          layout={'Two Column'}
          section={feeSection.sectionData}
          sectionDefinition={feeSection.sectionDefinition}
          orderId={orderId}
        />
      )}
      <FeeSectionTable
        feeSection={feeSection}
        isRefinance={currentOrder.data.transaction.transaction_category === eTransactionCategory.Refinance}
        layout={'Two Column'}
      />
    </StyledFeeSection>
  );
};
